// ============================================================================
// LINE INTERSECTION - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'line-intersection',
  name: 'Line Intersection',
  category: 'Geometry',
  complexity: {
    time: 'O(1)',
    space: 'O(1)'
  },
  description: 'Algorithm to find the intersection point of two line segments in 2D space using cross product to determine intersection and calculate the exact point. Handles parallel lines, collinear lines, and edge cases where lines do not intersect.'
};
